import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { Observable, of } from 'rxjs';
import { OrganizationInterface } from '../plasma-ui-common/interfaces/organization.interface';
import { OrganizationService as LibOrganizationService } from '../plasma-ui-common/synlab-access-ui-components/core/organization/organization.service';
import { ResponseInterface } from '../plasma-ui-common/interfaces/response.interface';
import { ConfigService } from '../service/config/config.service';

@Injectable({
  providedIn: 'root',
})
export class OrganizationService implements LibOrganizationService {
  public readonly selectedOrg = signal<string>('');

  public organizations$: Observable<OrganizationInterface[]> = of([]);

  constructor(
    private readonly http: HttpClient,
    private readonly configService: ConfigService,
  ) {}

  public getAll() {
    const request = this.http.get<OrganizationInterface[]>(
      `${this.configService.baseAuthUrl}/api/organizations`,
    );
    return request.toPromise();
  }

  public async getUserOrgs(userId: string, synlabId: string) {
    const request = this.http.get<OrganizationInterface[]>(
      `${this.configService.baseAuthUrl}/api/organizations/select-user-org`,
      {
        params: {
          userId,
          synlabId,
        },
      },
    );
    return request.toPromise();
  }

  public async loadCurrentOrganization() {
    try {
      const organization = await this.getUserSessionOrg();
      if (organization) {
        this.selectedOrg.set(organization.organizationId);
      }
    } catch {
      console.log('Error fetching latest selected org');
    }
  }

  public async getUserSessionOrg() {
    const request = this.http.get<OrganizationInterface>(
      `${this.configService.baseAuthUrl}/api/organizations/latest-selected-org`,
    );
    return request.toPromise();
  }

  public saveOrgId(orgId: string) {
    const baseAuthUrl = this.configService.baseAuthUrl;
    const request = this.http.post<ResponseInterface<{ synlabId: string; userId: string }>>(
      `${baseAuthUrl}/api/organizations/select-org/${orgId}`,
      {},
    );
    return request.toPromise();
  }

  public async doSaveOrgId(orgId: string) {
    await this.saveOrgId(orgId);
    window.location.reload();
  }
}
